import changeWeekStartOption from '../../actions/weekStart/changeWeekStartOption';
import DayOfWeek from 'owa-service/lib/contract/DayOfWeek';
import WeekStartViewState from '../../store/schema/WeekStartViewState';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';

const changeWeekStartOptionMutator = mutator(
    changeWeekStartOption,
    (actionMessage: { newWeekStart: DayOfWeek }) => {
        const store = getOptionsStore();
        if (store?.activeViewState) {
            const { newWeekStart } = actionMessage;
            const viewState = store.activeViewState as WeekStartViewState;
            if (viewState.WeekStartDay !== newWeekStart) {
                // here we should not allow an empty string
                viewState.WeekStartDay = newWeekStart;
                viewState.isDirty = true;
            }
        }
    }
);

// exported only for testing purposes
export default changeWeekStartOptionMutator;
